import React from 'react';
import './Kpetseries.css';
import cavityImage from '../../../imgs/Kpetseries.webp';

const Kpetseries = () => {
    return (
        <div className="Kpetse-container">
            <div className='Cavitys'>
                <h2 className="Kpetse-title">Advantages of Powerjet Preform Injection Molding Machines</h2>
                <div className="Kpetse-content">
                    <p className="Kpetse-text">
                        And through our test comparison and analysis, our screw  L/D ratio is more reasonable. Moreover, it can significantly increase the plasticizing speed and reduce the plasticizing temperature, so as to effectively reduce the amount of acetaldehyde release (AA value) and improve the quality of the preform.
                    </p>
                    <p className="Kpetse-date">POWERJET KPET series high-speed preform injection molding machines</p>
                    <p className="Kpetse-text"> are accurate and fast; plasticizing and mold opening and closing are synchronized to shorten the production cycle, ensure product quality, and improve product competitiveness.
                        Application: suitable for a 48-cavity, 64-cavity, 72-cavity water preform with a weight between 11g and 20g with high comprehensive benefit.</p>
                </div>
                <div className="Kpetse">
                    <img src={cavityImage} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />

                </div>
            </div>

        </div>
    );
};

export default Kpetseries;
